import { DATE_YYYY_MM_DD, DATE_TIME_YYYY_MM_DD_HH_mm_ss } from 'common/constans/date.constants';
import dayjs from 'dayjs';
import { IGuestRead } from '../services/residents-service/residents.service.types';
import { ServerGuestValidity } from '../enums/guest-validity.enum';

export enum TimeDirection {
  Before = 'Before',
  After = 'After',
}

export const DateToFormat = (date: string, format: string) => date && dayjs.utc(date, 'YYYY-MM-DD').format(format);
export const StrToDate = (date: string | null, format: string = DATE_YYYY_MM_DD) => (date ? dayjs.utc(date, format) : null);
export const StrToDateTimeLocal = (date?: string | null) => {
  if (!date) {
    return null;
  }

  return dayjs.utc(date, DATE_TIME_YYYY_MM_DD_HH_mm_ss).local();
};
export const formatCustomDateTime = (date: string | number | Date | null | undefined, includeTime: boolean = false) => {
  if (!date) {
    return null;
  }

  let parsedDate;

  if (typeof date === 'number') {
    parsedDate = new Date(date * 1000);
  } else if (typeof date === 'string') {
    parsedDate = dayjs(date).toDate();
  } else {
    parsedDate = date;
  }

  const formatString = includeTime ? 'MMM D, YYYY h:mma' : 'MMM D, YYYY';
  return dayjs(parsedDate).format(formatString);
};

export const getDateRangePeriod = (rowData: IGuestRead) =>
  rowData.validity === ServerGuestValidity.DateRange
    ? `${formatCustomDateTime(rowData?.startDate)} - ${formatCustomDateTime(rowData?.endDate)}`
    : rowData.validity;

export const formatCustomDateTimeForLPR = (timestamp: number | null) => {
  if (!timestamp) {
    return null;
  }
  const parsedDate = new Date(timestamp);
  return dayjs(parsedDate).format('DD/MM/YYYY hh:mm A');
};

export const checkDateInRange = (
  timeDirection: TimeDirection,
  dateFrom: dayjs.Dayjs | null,
  dateToCheck: dayjs.Dayjs | null,
  daysCount: number,
): boolean => {
  const dateFromClone = dateFrom?.clone().utc().startOf('day');
  const dateToCheckClone = dateToCheck?.clone().utc().startOf('day');

  if (!dateFromClone || !dateToCheckClone) return true;

  const start = timeDirection === TimeDirection.After ? dateFromClone : dateFromClone.clone().subtract(daysCount, 'days');
  const end = timeDirection === TimeDirection.After ? dateFromClone.clone().add(daysCount, 'days') : dateFromClone;

  return dateToCheckClone.isAfter(start) && dateToCheckClone.isBefore(end);
};

export const isRentExpired = (rentStart?: string | null, rentEnd?: string | null): boolean => {
  if (!rentStart || !rentEnd) {
    return true;
  }

  const today = dayjs().startOf('day');
  const start = dayjs(rentStart, 'YYYY-MM-DD');
  const end = dayjs(rentEnd, 'YYYY-MM-DD');

  if (!start.isValid() || !end.isValid()) {
    return true;
  }

  if (today.isBefore(start)) {
    return true;
  }

  const isActive = today.isBetween(start, end, 'day', '[]');

  return !isActive && today.isAfter(end);
};
